import React, { useContext, useState, Fragment } from 'react';
import { AlignCenter } from 'react-feather';
import { Link } from 'react-router-dom';
import { H2, H3, Image } from '../../AbstractElements';
import CheckContext from '../../_helper/Customizer';
import { useRecoilValue } from 'recoil';
import { adminAtom } from '../../recoil/atoms';

const Leftbar = () => {

    const { mixLayout, toggleSidebar} = useContext(CheckContext);
    const [toggle, setToggle] = useState(false);
    const admin = useRecoilValue(adminAtom);


    const openCloseSidebar = () => {
        setToggle(!toggle);
        toggleSidebar(!toggle);
    };

    return (
        <Fragment>
            <div className="main-header-left">
                {mixLayout ?
                    <div className="logo-wrapper">
                        <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                        <H3>{"Clock It In"}</H3>
                            {/* <Image attrImage={{ className: 'img-fluid d-inline', src: `${require('../../assets/images/logo/logo.png')}`, alt: '' }} /> */}
                        </Link>
                    </div>
                    :
                    <div className="dark-logo-wrapper">
                        <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                        <h4 className='m-0'>{"Clock It In"}</h4>
                            {/* <Image attrImage={{ className: 'img-fluid d-inline', src: `${require('../../assets/images/logo/dark-logo.png')}`, alt: '' }} /> */}
                        </Link>
                    </div>
                }
                <div className="toggle-sidebar" onClick={() => openCloseSidebar()}>
                    <AlignCenter className="status_toggle middle" id="sidebar-toggle" />
                </div>
            </div>
        </Fragment >
    );
};

export default Leftbar;